// Budsjettår: januar – desember 2026
// Måneder 0 t.o.m. GJENNOMFORT_TOM-1: gjennomførte måneder med faktiske tall
// Resten: budsjett basert på snitt 2025

export const MAANEDER = ['Jan','Feb','Mar','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Des'];
export const MAANED_KORT = ['Jan 26','Feb 26','Mar 26','Apr 26','Mai 26','Jun 26','Jul 26','Aug 26','Sep 26','Okt 26','Nov 26','Des 26'];
export const GJENNOMFORT_TOM = 7; // jan–jul (0–6) er gjennomført/låst — oppdater når ny måned avsluttes
export const AAR = 2026;

export const INNTEKTER = {
  'Terje — DSD Explore': {
    budsjett: [ 92000,92000,92000,92000, 92000,225000,92000,92000,92000,92000,92000,92000],
    note: 'Budsjett 92 000 = netto. Faktisk føres brutto (hele DSD-utbetalingen inkl. SEB-refusjon) — motsvares av utgift under Jobbutlegg Terje. Jun = feriepenger ~310 000 kr.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Elin — Hustadvika': {
    budsjett: [19232,19232,19232,19232, 19232,19232,19232,19232,19232,19232,19232,19232],
    note: 'Fast 19 232 kr/mnd hele året.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Elin — Helse M&R': {
    budsjett: [16094,15663,15942,18074, 11755,50000,11755,11755,11755,11755,11755,11755],
    note: 'Jan–apr faktisk. Mai–des snitt 11 755 kr. Jun = feriepenger estimat.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Husleie': {
    budsjett: [13000,13405,13405,13405, 13405,13405,13405,13405,13405,13405,13405,13405],
    note: '13 405 kr/mnd. Jan faktisk 13 000 kr.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
};

export const FASTE_UTGIFTER = {
  'Boliglån — renter': {
    budsjett: [23653,23653,21371,23653, 23273,23273,23273,23273,23273,23273,23273,23273],
    note: 'Jan–apr faktisk. Mai–des snitt 2025.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Billeasing (DNB Finans)': {
    budsjett: [13662,13662,13662,13662, 13884,13884,13884,13884,13884,13884,13884,13884],
    note: 'Jan–apr faktisk. Mai–des snitt 2025.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Forsikring': {
    budsjett: [12989,9057,16921,12989, 11961,11961,11961,11961,11961,11961,11961,11961],
    note: 'Jan–apr faktisk. Mai–des snitt 2025.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Strøm': {
    budsjett: [8315,11922,10301,7501, 4161,4161,4161,4161,4161,4161,4161,4161],
    note: 'Jan–apr faktisk. Mai–des snitt 2025. Sesongvariert.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Kommunale avgifter': {
    budsjett: [0,68,15936,3098, 5976,5976,5976,5976,5976,5976,5976,5976],
    note: 'Jan–apr faktisk. Mai–des snitt 2025. Kvartalsvis.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Internett / mobil': {
    budsjett: [2118,2212,2239,4299, 2122,2122,2122,2122,2122,2122,2122,2122],
    note: 'Jan–apr faktisk. Mai–des snitt 2025.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Studielån': {
    budsjett: [1993,1982,1982,1980, 1776,1776,1776,1776,1776,1776,1776,1776],
    note: 'Jan–apr faktisk. Mai–des snitt 2025.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Vask / renhold': {
    budsjett: [0,0,0,0, 2081,2081,2081,2081,2081,2081,2081,2081],
    note: 'Jan–apr ingen registrert. Mai–des snitt 2025.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Barn og familie': {
    budsjett: [2003,4631,5668,366, 422,422,422,422,422,422,422,422],
    note: 'Jan–apr faktisk. Mai–des snitt 2025.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Nordnet — sparing': {
    budsjett: [10400,400,400,400, 10250,10250,10250,10250,10250,10250,10250,10250],
    note: 'Jan–apr faktisk. Mai–des snitt 2025.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Molde Båthavn': {
    budsjett: [0,0,0,6503, 0,0,0,0,0,0,0,6503],
    note: 'Apr faktisk. Des budsjettert årsavgift.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Lønn Terje': {
    budsjett: [7000,7000,7000,7000, 7000,7000,7000,7000,7000,7000,7000,7000],
    note: 'Fast månedlig overføring fra Regningskonto til Terje brukskonto.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Lønn Elin': {
    budsjett: [7000,7000,7000,7000, 7000,7000,7000,7000,7000,7000,7000,7000],
    note: 'Fast månedlig overføring fra Regningskonto til Elin brukskonto.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Lønn Joshua': {
    budsjett: [400,400,400,400, 400,400,400,400,400,400,400,400],
    note: 'Fast månedlig overføring fra Regningskonto til Joshua.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Skatt / offentlig': {
    budsjett: [0,0,0,0, 0,0,0,0,0,0,0,0],
    note: 'Ny kategori fra aug 2026 — Skatteetaten/innkreving, synlig via bankkonto-synk. Budsjett settes når reelt nivå er kjent.',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Diverse': {
    budsjett: [0,0,0,0, 2000,2000,2000,2000,2000,2000,2000,2000],
    note: 'Ukategorisert bankkonto-forbruk (Vipps m.m.) — synkes fra mai 2026. Jan–apr er historiske tall. Flytt gjengangere til riktig kategori via læring.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Jobbutlegg Terje': {
    budsjett: [0,0,0,0, 0,0,0,0,0,0,0,0],
    note: 'SEB kredittkortregning — jobbutlegg refundert av DSD Explore. Føres som faktisk utgift (brutto-modell); refusjonen ligger i DSD-inntekten, så netto går i null.',
    laast: [true,true,true,true,false,false,false,false,false,false,false,false],
  },
  'Vedlikehold hus': {
    budsjett: [0,0,0,0, 0,0,0,0,0,0,0,0],
    note: 'Budsjetteres fra 2027 — opprettet sep 2026',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Vedlikehold hytte': {
    budsjett: [0,0,0,0, 0,0,0,0,0,0,0,0],
    note: 'Budsjetteres fra 2027 — opprettet sep 2026',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
};

export const KREDITTKORT = {
  'Dagligvarer': {
    budsjett: [13815,7556,9134,6771,9500,9500,9500,9500,9500,9500,9500,9500],
    note: 'Jan–apr faktisk. Mai–des justert fra snitt 9 319 kr/mnd (var 11 000).',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Reise og hotell': {
    budsjett: [93108,2011,25,11359,7000,7000,7000,7000,7000,7000,7000,7000],
    note: 'Jan–apr faktisk. Mai–des hevet til 7 000 kr/mnd — jan-outlier (93k) var engangs, men familien reiser jevnlig (var 4 000).',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Elektronikk / digitalt': {
    budsjett: [3396,3616,4630,6835,4500,4500,4500,4500,4500,4500,4500,4500],
    note: 'Jan–apr faktisk. Mai–des justert fra snitt 4 619 kr/mnd (var 2 000).',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Klær, hjem og interiør': {
    budsjett: [289,526,4087,20888,3500,3500,3500,3500,3500,3500,3500,3500],
    note: 'Jan–apr faktisk (apr 20 888 var sesongkjøp). Mai–des hevet til 3 500 kr/mnd (var 2 500).',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Restaurant og kafe': {
    budsjett: [662,5414,803,3033,2500,2500,2500,2500,2500,2500,2500,2500],
    note: 'Jan–apr faktisk. Mai–des justert fra snitt 2 478 kr/mnd (var 2 000).',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Streaming / abonnement': {
    budsjett: [0,0,0,1038,1200,1200,1200,1200,1200,1200,1200,1200],
    note: 'Spotify, Netflix, Apple m.fl.',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Drivstoff og parkering': {
    budsjett: [206,70,0,171,500,500,500,500,500,500,500,500],
    note: 'Snitt fra 2025.',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Sport og aktivitet': {
    budsjett: [998,1039,0,0,1000,1000,1000,1000,1000,1000,1000,1000],
    note: 'Snitt fra 2025.',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Dyr / kjæledyr': {
    budsjett: [0,0,0,498,2000,2000,2000,2000,2000,2000,2000,2000],
    note: 'Musti Molde m.fl. Snitt fra 2025.',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Hage og blomster': {
    budsjett: [0,0,0,4414,1000,1000,1000,1000,1000,1000,1000,1000],
    note: 'Haukebo Hagesenter, Plantasjen.',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Helse': {
    budsjett: [0,0,0,0,0,0,0,0,0,0,0,0],
    note: 'Ny kategori fra aug 2026 — apotek, lege, tannlege, Ouraring m.m. Budsjett settes når reelt nivå er kjent etter noen måneder.',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Trening': {
    budsjett: [0,0,0,0,0,0,0,0,0,0,0,0],
    note: 'Ny kategori fra aug 2026 — medlemskap og treningsaktiviteter (SATS, padel m.m.). Budsjett settes når reelt nivå er kjent.',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Hytte': {
    budsjett: [0,0,0,0,0,0,0,0,0,0,0,0],
    note: 'Ny kategori fra aug 2026 — hytterelaterte kjøp, fylles via manuell omkategorisering og læring. Budsjett settes når reelt nivå er kjent.',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
  'Diverse øvrig (KK)': {
    budsjett: [21997,19528,21959,3811,15000,15000,15000,15000,15000,15000,15000,15000],
    note: 'Jan–apr faktisk. Mai–des justert fra snitt 16 824 kr/mnd (var 12 000).',
    laast: [false,false,false,false,false,false,false,false,false,false,false,false],
  },
};

export function budsjettSum(obj, maaned) {
  return Object.values(obj).reduce((s, v) => s + (v.budsjett[maaned] || 0), 0);
}
export function budsjettAar(obj) {
  return Object.values(obj).reduce((s, v) =>
    s + v.budsjett.reduce((a, b) => a + b, 0), 0);
}
export function erLaast(kat_obj, kat, maaned) {
  return kat_obj[kat]?.laast?.[maaned] === true;
}
export function netto(maaned) {
  return budsjettSum(INNTEKTER, maaned)
    - budsjettSum(FASTE_UTGIFTER, maaned)
    - budsjettSum(KREDITTKORT, maaned);
}
export function formatNOK(n, sign = false) {
  const abs = Math.abs(Math.round(n));
  const str = abs.toLocaleString('no-NO') + ' kr';
  if (sign) return (n >= 0 ? '+' : '−') + str;
  return (n < 0 ? '−' : '') + str;
}
